var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1856 9.66653C13.28 9.75511 13.333 9.87523 13.333 10.0005C13.333 10.1257 13.28 10.2458 13.1856 10.3344L8.3587 14.8622C8.28829 14.928 8.19867 14.9728 8.10114 14.991C8.00361 15.0091 7.90254 14.9998 7.81067 14.9641C7.71879 14.9284 7.64023 14.8681 7.58489 14.7906C7.52955 14.7131 7.4999 14.622 7.49968 14.5287L7.49968 5.47318C7.4995 5.37964 7.52893 5.28815 7.58425 5.21032C7.63957 5.13249 7.71827 5.07182 7.81039 5.036C7.90251 5.00018 8.0039 4.99083 8.10169 5.00912C8.19949 5.02742 8.28929 5.07254 8.35971 5.13877L13.1856 9.66653Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevron);
export default __webpack_public_path__ + "static/media/RightChevron.a5d740cdae7e3a152c7480e3156cc65b.svg";
export { ForwardRef as ReactComponent };